import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0bf1154c")

_pushScopeId("data-v-0bf1154c")
const _hoisted_1 = { class: "log__group" }
const _hoisted_2 = {
  key: 0,
  class: "listState"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "icon-spinner animate-spin" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "Loading...", -1)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "log__subtitle" }
const _hoisted_7 = { class: "log__title" }
const _hoisted_8 = { class: "log__description" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.logsLoading)
        ? (_openBlock(), _createBlock("span", _hoisted_2, [
            _hoisted_3,
            _hoisted_4
          ]))
        : _createCommentVNode("", true),
      _createVNode("ul", null, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.logs, (log, idx) => {
          return (_openBlock(), _createBlock("li", { key: idx }, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", {
                class: ["row__title", _ctx.rowClass(idx)]
              }, [
                _createVNode("div", {
                  class: ["log__type", _ctx.badgeClass(idx)]
                }, [
                  _createVNode("span", null, _toDisplayString(log.actionType), 1)
                ], 2),
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.logDate(idx)), 1),
                _createVNode("div", _hoisted_7, _toDisplayString(log.db_collection), 1),
                _createVNode("div", _hoisted_8, _toDisplayString(log.description), 1)
              ], 2)
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
})